// v1.2.0 · Preguntas frecuentes: las objeciones de un gerente antes de contratar software a medida
import React from 'react';
import { faq } from '../../data/site';

export default function SiteFaq() {
  return (
    <section id="preguntas" data-scan className="seam scroll-mt-24 border-t border-[var(--line)] bg-[var(--sheet)] py-20 lg:py-28">
      <div className="mx-auto grid max-w-[1240px] gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.6fr] lg:gap-16">
        <h2 data-reveal className="display text-[2.8rem] sm:text-[3.6rem]">Antes de empezar, nos suelen preguntar</h2>
        <div data-reveal style={{ '--rd': '120ms' }} className="border-b border-[var(--line)]">
          {faq.map((f, i) => (
            <details key={f.q} className="faq group border-t border-[var(--line)]" open={i === 0}>
              <summary className="flex cursor-pointer list-none items-start justify-between gap-6 py-6 text-[1.15rem] font-semibold leading-snug">
                {f.q}
                <span aria-hidden className="faq-mark mt-1 h-4 w-4 shrink-0" />
              </summary>
              <p className="measure pb-7 text-[16px] leading-[1.65] text-[var(--ink-2)]">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
